import React from "react";
import { TextHeader } from "components/Texts";

import Row from "components/Row";
import SigninButton from "components/gads/SigninButton";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Setup = () => {
  const { REACT_APP_GOOGLE_ADS_SETUP_MANUAL_URL } = process.env;
  const googleAdsLearnMoreUrl = "https://support.google.com/adwords/answer/6139186";
  const termsUrl = "https://terms.readyplanet.com/rmp-terms-of-service";
  const privacyUrl = "https://terms.readyplanet.com/privacy-policy";

  //eslint-disable-next-line no-unused-vars
  const [t, i18n] = useTranslation();

  const view = () => {
    return (
      <StyledContainer>
        <SetupWrapperHeader>
          <SetupTextHeader>{t("__ads_setup_title")}</SetupTextHeader>
          <StyledManualLink>
            <StyledHelpLink target="_blank" href={REACT_APP_GOOGLE_ADS_SETUP_MANUAL_URL}>
              <HelpIcon src="/images/help_outline.svg" />
              {t("__ads_setup_manual_link")}
            </StyledHelpLink>
          </StyledManualLink>
        </SetupWrapperHeader>

        <Row alignItems="stretch" className="m-b-10">
          {t("__ads_setup_description")}
        </Row>

        <div className="m-b-10">
          {t("__ads_setup_learn_more")}&nbsp;
          <wbr />
          <StyledLink target="_blank" href={googleAdsLearnMoreUrl}>
            {t("__ads_setup_learn_more_link")}
          </StyledLink>
        </div>

        <div className="m-b-10">
          <SigninButton />
        </div>
        <div className="links-container">
          <StyledLink target="_blank" href={termsUrl}>
            {t("__ads_setup_policy_link")}
          </StyledLink>
          &nbsp;|&nbsp;
          <StyledLink target="_blank" href={privacyUrl}>
            {t("__ads_setup_privacy_link")}
          </StyledLink>
        </div>
      </StyledContainer>
    );
  };

  return view();
};

export default Setup;

const SetupWrapperHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
          		  <InputInTable  type="text" full placeHolder="0.00" value={inputFields[i].conversion_value} onChange={e => handleFormChange(index, e, e.following)}  margin="10px 0px !important" />
          		</td>
`;

const SetupTextHeader = styled(TextHeader)`
  font-size: 18px;
  margin-bottom: 10px;
`;

const StyledManualLink = styled.div`
  text-align: right;
  margin-bottom: 10px;
`;

const StyledHelpLink = styled.a`
  text-decoration: none;
  color: #337ab7;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
  width: fit-content;

  &:hover {
    text-decoration: underline;
  }
`;

const StyledLink = styled.a`
  text-decoration: none;
  color: #337ab7;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

const StyledContainer = styled.div`
  font-size: 14px;
  color: #555;

  .m-b-10 {
    margin-bottom: 10px;
  }

  @media screen and (max-width: 834px) {
    .links-container {
      display: flex;
      justify-content: center;
    }
  }
`;

const HelpIcon = styled.img`
  width: 16px;
  height: 16px;
  margin-right: 6px;
`;
